/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import { API_ENDPOINTS } from "../../Constants";

export default {
  getBusTripsList: (params) => {
    return axios.get(API_ENDPOINTS.GET_BUS_TRIPS_LIST, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
        "x-tenant-slug": "default",
      },
      params,
    });
  },
  createBusTrip: (data) => {
    return axios.post(API_ENDPOINTS.GET_BUS_TRIPS_LIST, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
        "x-tenant-slug": "default",
      },
    });
  },
  getBusTripById: (id) => {
    return axios.get(`${API_ENDPOINTS.GET_BUS_TRIPS_LIST}/${id}`, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
        "x-tenant-slug": "default",
      },
    });
  },
  updateBusTrip: (id, data) => {
    return axios.patch(`${API_ENDPOINTS.GET_BUS_TRIPS_LIST}/${id}`, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
        "x-tenant-slug": "default",
      },
    });
  },
  deleteBusTrip: (id) => {
    return axios.delete(`${API_ENDPOINTS.GET_BUS_TRIPS_LIST}/${id}`, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
        "x-tenant-slug": "default",
      },
    });
  },
};
